import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class ConfigService {
    basePath: string = environment.apiURI;
    apiURI: string = environment.apiURI + 'api/v1/';
    apiURIv2: string = environment.apiURI + 'api/v2/';

    appAdminURI: string = environment.appAdminURI;

    isQA: boolean = environment.isQA;
    market: string = environment.market;
    //year: number = 2018;
    customerLogin = 'public/member/login';
    customerLogout = 'oauth/logout';

    fundraisingLogin = 'public/fundraiser/login';
    fundraisingOtpLogin = 'public/fundraiser/otp';

    customerRegister = 'public/member/register';
    customerForgotPassword = 'public/member/forgot-password';
    fundraisingForgotPassword = 'public/fundraiser/forgot-password';

    resetPassword(id, token) {
        return 'public/member/reset-password/' + id + '/' + token;
    }

    resetFundraiser(id, token) {
        return 'public/fundraiser/reset-password/' + id + '/' + token;
    }


    refreshToken: string = this.apiURI + 'public/refreshtoken';

    constructor() {
    }

    getSavings: string = this.apiURI + 'transaction/member/list';
    getRedeemStats: string = this.apiURI + 'transaction/member/redeemStats';
    getOrders: string = this.apiURI + 'member/order/history/list';

    salesRepList: string = this.apiURI + 'admin/sales-rep/list';

    getOrder(id) {
        return this.apiURI + 'member/order/' + id;
    }

    createOrder(id) {
        return this.apiURI + 'member/order/' + id;
    }

    makeOrder: string = this.apiURI + 'member/order';
    getOrderPrice: string = this.apiURI + 'member/order/price';

    changeMemberPassword: string = 'member/change-password';

    setBeneficiary(id) {
        if (id == '') {
            return 'member/beneficiary';
        } else {
            return 'member/beneficiary?beneficiaryId=' + id;
        }
    }

    createSubscription: string = this.apiURI + 'member/membership_subscription';

    cancelSubscription(id) {
        return this.apiURI + 'member/membership_subscription/' + id + '/cancel';
    }

    getMemberDetails: string = 'member/details';
    addProductCard: string = 'member/addcard';
    updateMemberProfile: string = 'member/update';
    addMemberAddress: string = 'member/address';

    getCategories: string = this.apiURI + 'admin/product/categories';
    getProductList: string = this.apiURI + 'member/product/list';

    categoriesList: string = 'public/settings/categories';

    getActiveCategoriesList(marketId) {
        return 'member/browse/market/' + marketId + '/categories?includeImages=true';
    }

    getActiveOrderedCategoriesList() {
        return 'member/browse/categories?includeImages=true';
    }

    getSearchResults: string = 'member/browse/nearby';
    contactCompany: string = 'member/mailto-axxess';
    createAccount: string = 'public/fundraiser/register';
    getBenefactorList: string = this.apiURI + 'public/settings/benefactors';

    getLocationDetails(id) {
        return 'member/browse/location/' + id;
    }

    getMerchantLocation(id, bid) {
        return 'merchant/location/' + id + '?bid=' + bid;
    }

    getLocationOffers(id) {
        return 'member/browse/location/' + id + '/offers';
    }

    getMemberBeneficiaries: string = this.apiURI + 'member/beneficiaries/list';

    getProductByCardNum: string = this.apiURI + 'admin/product/card-code/';

    createMembershipSubscription: string = this.apiURI + 'admin/membership_subscription';

    publicMarketsList: string = this.apiURI + 'member/browse/market/list';

    getProductDetails(id) {
        return this.apiURI + 'member/product/' + id;
    }

    getMemberStatistics: string = 'member/statistics';
    checkUserMail: string = 'public/member/register/check-mail';
}



// WEBPACK FOOTER //
// ./src/app/config/config.service.ts